var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.googleAuth)?_c('v-btn',{staticClass:"px-4",attrs:{"rounded":"","large":"","dark":"","color":"red darken-4"},on:{"click":_vm.login}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-google")]),_vm._v(" Google\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }